/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { AccessRequestsAppAccessRule } from './AccessRequestsAppAccessRule';
import {
    AccessRequestsAppAccessRuleFromJSON,
    AccessRequestsAppAccessRuleFromJSONTyped,
    AccessRequestsAppAccessRuleToJSON,
    AccessRequestsAppAccessRuleToJSONTyped,
} from './AccessRequestsAppAccessRule';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetAccessRequestsAppRulesMe200Response
 */
export interface GetAccessRequestsAppRulesMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<AccessRequestsAppAccessRule>}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    result: Array<AccessRequestsAppAccessRule>;
}

/**
 * Check if a given object implements the GetAccessRequestsAppRulesMe200Response interface.
 */
export function instanceOfGetAccessRequestsAppRulesMe200Response(value: object): value is GetAccessRequestsAppRulesMe200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetAccessRequestsAppRulesMe200ResponseFromJSON(json: any): GetAccessRequestsAppRulesMe200Response {
    return GetAccessRequestsAppRulesMe200ResponseFromJSONTyped(json, false);
}

export function GetAccessRequestsAppRulesMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsAppRulesMe200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(AccessRequestsAppAccessRuleFromJSON)),
    };
}

export function GetAccessRequestsAppRulesMe200ResponseToJSON(json: any): GetAccessRequestsAppRulesMe200Response {
    return GetAccessRequestsAppRulesMe200ResponseToJSONTyped(json, false);
}

export function GetAccessRequestsAppRulesMe200ResponseToJSONTyped(value?: GetAccessRequestsAppRulesMe200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value['result'] as Array<any>).map(AccessRequestsAppAccessRuleToJSON)),
    };
}

